<template>
  <div class="row progress-bar">
    <div class="col-12">
      <div class="value-bar" :style="valueBarStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    percent: {
      type: Number,
      required: true,
    },
  },
  computed: {
    valueBarStyle() {
      return {
        width: `${this.percent}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-bar {
  padding: 0;
  .col-12 {
    background-color: rgba(53, 54, 61, 0.1);
    border-radius: 8px;
    height: 16px;
    padding: 0;
    overflow: hidden;
  }
  .value-bar {
    background: rgb(51, 128, 195);
    background: linear-gradient(
      90deg,
      rgba(51, 128, 195, 1) 0%,
      rgba(98, 45, 144, 1) 49%
    );
    height: 100%;
    border-radius: 8px;
  }
}
</style>

